/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'personal-info',
  template: require('./personal-info.component.html')
})
export class PersonalInfoComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
    const personalInfo = this.appActions.getData('PersonalInformation', {});
    const yourInfo = this.appActions.getData('YourInformation', {});

    this.maritalStatusLocal = personalInfo.maritalStatus;

    if (this.flowManager.isAuthed && personalInfo.dob != null) {
      this.form.inputs.dob.labelPosition = 'leftMask';
      this.form.inputs.dob.attr.classes = 'col s12 m5 padding-top-6';
    }

    if (!this.flowManager.isAuthed || (this.flowManager.isAuthed && personalInfo.ssn == null)) {
      this.form.buttons.inputs.next.path = '/ssn';
    } else {
      this.form.buttons.inputs.next.path = '/personal-address';
    }

    // Redux check to see if prepop failed
    const prepopFailed = this.appActions.getData('prepopFailed', false);

    if (yourInfo.firstName == null || yourInfo.lastName == null || prepopFailed) {
      this.form.inputs.firstName.showUp = true;
      this.form.inputs.firstName.require = true;
      this.form.inputs.middleInitial.showUp = true;
      this.form.inputs.lastName.showUp = true;
      this.form.inputs.lastName.require = true;
      this.form.inputs.email.showUp = true;
      this.form.inputs.email.require = true;
      this.appActions.setData('prepopFailed', true);
    }

    if (!prepopFailed && this.form.inputs.email.showUp === false && !yourInfo.email) {
      this.form.inputs.email.showUp = true;
      this.form.inputs.email.require = true;
    }

    // Check for existing customer to hide security question/answer
    if (this.flowManager.isTkCustomer === true) {
      this.form.inputs.securityQuestion.showUp = false;
      this.form.inputs.securityQuestion.require = false;
      this.form.inputs.securityAnswer.showUp = false;
      this.form.inputs.securityAnswer.require = false;

      // Adding this for "Basic Information" step title link authed users
      this.router.navigate(['/personal-info-auth'], {});
    }
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('personal-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.flowManager.promoCode === false) {
      delete this.form.inputs.promoCode;
    } else {
      this.form.inputs.promoCode.noneditable = this.flowManager.promoCode;
      this.appActions.setData('PersonalInformation.promoCode', this.flowManager.promoCode);
    }
  }

  btnClick(e) {
    this.handleClick(e.action);
  }
}
